import React, { useEffect } from "react";
import { FC } from "react";
import { useMemo } from "react";
import { useHistory, useLocation } from "react-router";
import { Route } from "react-router";
import { Switch } from "react-router";
import { makeStyles } from "@material-ui/core";
import { Theme } from "@material-ui/core";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import { AdapterLink } from "../../../../../components/Adopter";
import Error from "../../../../../components/Error";
import { useUserAccount } from "../../context";
import Profile from "./Profile";
import Payments from "./Payments";
import { StudentApplications } from "../../../../application/components/StudentApplications";
import { Routes } from "../../../../../constants/routes";
import BillingPage from "../../../../billing/pages/BillingPage";
import MessagesPageWrapper from "../../../../message/MessagesPageWrapper";

const useStyles = makeStyles((theme: Theme) => ({
  tabs: {
    marginBottom: theme.spacing(4),
  },
  tabLink: {
    "&:hover": {
      textDecoration: "none",
    },
  },
}));

const Student: FC = () => {
  const classes = useStyles();

  const defaultProfile = { data: undefined };

  const {
    userIsAuthUser,
    profile: { data: { data: profile } = defaultProfile },
    user,
    path,
  } = useUserAccount();
  const history = useHistory();
  const { pathname } = useLocation();
  const pieces = pathname.split(`${path}`);
  const value = pieces[pieces.length - 1].replace(/^\/|\/$/g, "");

  useEffect(() => {
    if (value === "") {
      history.replace({
        pathname: pathname + `/${Routes.APPLICATIONS}`,
      });
    }
  }, []);

  const tabs = useMemo(
    () => [
      {
        label: "Applications",
        component: () => <StudentApplications studentId={user?.id} />,
        path: `/${Routes.APPLICATIONS}`,
      },
      {
        label: "Billing",
        component: () => (
          <BillingPage studentId={user?.id} showFilter={false} />
        ),
        path: `/${Routes.BILLING}`,
      },
      {
        label: "Messages",
        component: () => <MessagesPageWrapper studentId={user?.id} />,
        path: `/${Routes.MESSAGES}`,
      },
    ],
    [profile, userIsAuthUser],
  );

  return (
    <>
      <Tabs value={value} variant="scrollable" className={classes.tabs}>
        {tabs.map((item, index) => (
          <Tab
            component={AdapterLink}
            className={classes.tabLink}
            key={index}
            label={item.label}
            value={item.path.replace(/^\/|\/$/g, "")}
            to={path + item.path}
          />
        ))}
      </Tabs>
      <Switch>
        {tabs.map((item, index) => (
          <Route
            key={index}
            exact
            path={path + item.path}
            component={item.component}
          />
        ))}
        <Route
          path={`${path}/*`}
          component={() => <Error text={"Not found"} />}
        />
      </Switch>
    </>
  );
};

export default Student;
